import styled from '@emotion/styled';

export const WrappedPage = styled.div`
  color: ${({ theme }) => theme.color.black};
`;
